export const isPositiveAmount = (amountCents: number | undefined | null): boolean =>
  typeof amountCents === 'number' && amountCents > 0;
